import { Globals } from "../CoreApp/Globals";
import { appstr } from "./appstr";

export function AddHTMLSpinnerCancel(callback, cmdCode) {
  var spinnerPad = document.getElementById("spinner-pad");
  if (spinnerPad == null) return;
  var closeButtonClass = "ocn-btn ocn-btn--secondary ocn-btn--large";
  var cancelButton = document.createElement("button");
  cancelButton.setAttribute("class", closeButtonClass);
  cancelButton.setAttribute("type", "button");
  cancelButton.innerText = appstr("Cancel");
  cancelButton.style.margin = "15px";
  cancelButton.fCallbackObj = callback;
  cancelButton.fCmdCode = cmdCode;
  cancelButton.addEventListener("click", function (event) {
    var aCmd = Globals._wsMgr.AssembleCommand(null, this.fCallbackObj, this.fCmdCode);
    Globals._wsMgr.DoExecuteCommand(aCmd);
  });
  spinnerPad.appendChild(cancelButton);
  return cancelButton;
}
